import {AnyExtraCharge} from "../components/ExtraChargeList"

// TODO See the same constant in model/communication.kt
export const autoChargeDiscount = 5

export function createDateTime(date: string, hour: number, minute: number): string {
  const sHour = String(hour).padStart(2, "0")
  const sMinute = String(minute).padStart(2, "0")
  return date + "T" + sHour + ":" + sMinute + ":00"
}

export function extraChargesTotal(extraCharges: Array<AnyExtraCharge>): number {
  return extraCharges.reduce((total, charge) => total + charge.amount, 0)
}

export function centsToString(cents: number) {
  return (cents / 100).toFixed(2)
}

export function formatMoney(cents: number): string {
  // TODO Support other currencies
  return (cents / 100).toLocaleString("en-AU", {style: "currency", currency: "AUD"})
}

export function formatDollars(cents: number) {
  return "$" + (cents / 100).toFixed(0)
}

export function floor10cents(cents: number) {
  // This is typically used for *negative discounts* and we want them rounded down - more generous.
  // -101 -> -110, -109 -> -110
  return Math.floor(cents / 10) * 10
}

export function parseMoney(money: string): number | null {
  // TODO Support other currencies
  const regex = /^(-?)\$? *(\d+)(\.(\d*))?$/g
  const parts = regex.exec(money)
  if (parts == null) {
    return null
  }
  const [, sign, dollars, , cents = ""] = parts
  const value = Number.parseInt(dollars + cents.padEnd(2, "0").slice(0, 2), 10)
  return sign ? -value : value
}



// WEBPACK FOOTER //
// ./src/model/charges.ts